var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCiiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9178 48.3651C14.4554 49.7452 4.56517 45.605 1.3887 35.1376C-2.2713 23.2938 1.25852 7.87534 12.5101 2.49283C26.3095 -3.83823 45.1116 6.65154 47.8231 22.773C49.735 37.3397 35.7756 47.1934 23.9215 48.3614",
    fill: "#FEC508"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7794_19069",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 46,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5436 23.0567L22.0566 2.45605L1.45599 26.9431L25.943 47.5437L46.5436 23.0567Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7794_19069)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7794_19069",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 46,
    height: 46
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5436 23.0567L22.0566 2.45605L1.45599 26.9431L25.943 47.5437L46.5436 23.0567Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7794_19069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.967 24.0424C15.354 29.5256 13.6262 35.673 14.4472 36.3637C15.2682 37.0545 21.0293 34.3001 25.6422 28.8169C30.2551 23.3338 32.7272 17.8125 31.162 16.4957C29.5967 15.1788 24.5799 18.5593 19.967 24.0424ZM32.5525 18.0591C32.3855 20.977 29.5883 25.5689 26.3528 29.4148C23.5374 32.7613 20.5996 34.7914 19.1059 35.6994C18.6612 35.9649 18.1771 36.2382 17.6907 36.485C21.412 36.467 26.8641 33.1247 30.3339 29.0004C34.0056 24.6359 34.3082 20.7578 32.5477 18.0551L32.5525 18.0591ZM14.3045 31.6601C14.9476 30.0282 16.4409 26.7912 19.2564 23.4446C21.5426 20.727 24.0069 18.4216 26.191 16.9464C27.4112 16.1198 28.4756 15.605 29.3837 15.3931C26.4195 14.1212 22.6552 15.0869 18.9875 19.4466C15.5177 23.5709 13.1577 29.5145 13.7768 33.184C13.9367 32.6626 14.1231 32.1389 14.3085 31.6553L14.3045 31.6601ZM22.7626 9.46216C22.6638 9.45286 22.5919 9.54813 22.6309 9.63829C22.8873 10.2886 23.822 12.4525 25.4533 14.0709C27.4835 13.7044 29.3267 14.1645 30.819 15.1002C30.3803 14.0915 29.5771 12.6778 28.2004 11.5852C26.1586 9.95766 23.5182 9.54844 22.7626 9.46216ZM31.7646 15.7891C31.563 15.6194 31.3532 15.4594 31.1354 15.3089L32.4635 13.5646C32.6761 13.2924 33.0643 13.2501 33.3284 13.4722L33.7845 13.856C34.0486 14.0781 34.0692 14.4727 33.8415 14.7239L32.3501 16.3309C32.1646 16.142 31.9711 15.9628 31.7694 15.7931L31.7646 15.7891Z",
    fill: "#00625F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiiIcon);
export default __webpack_public_path__ + "static/media/cii-icon.4c6affcd2a5a73f80f316249baf8d3bc.svg";
export { ForwardRef as ReactComponent };